import { Observable } from 'rxjs';

import { ChannelNoiseReductionLevel, Response } from '@shure/shared/angular/data-access/system-api/models';

import { NoiseReductionChannel } from '../models';

export abstract class NoiseReductionApiService {
	/**
	 * Get channel that supports compressor.
	 */
	public abstract getChannel$(channelId: string): Observable<NoiseReductionChannel>;

	/**
	 * Enable/disable noise reduction for channel.
	 */
	public abstract toggleNoiseReduction(channelId: string, enabled: boolean): Observable<Response<void, string>>;

	/**
	 * Set noise reduction level for channel.
	 */
	public abstract setNoiseReductionLevel(
		channelId: string,
		level: ChannelNoiseReductionLevel
	): Observable<Response<void, string>>;

	/**
	 * Set noise reduction intensity level for channel.
	 */
	public abstract setNoiseReductionIntensity(
		channelId: string,
		percentage: number
	): Observable<Response<void, string>>;
}
